import { useState } from "react";

// material-ui
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select, { type SelectChangeEvent } from "@mui/material/Select";

// project imports
import { APPS, getCurrentApp } from "config/apps";

// ==============================|| HEADER CONTENT - APP SELECTOR ||============================== //

export default function AppSelector() {
  const [currentApp] = useState<string>(getCurrentApp());

  const handleChange = (event: SelectChangeEvent<string>) => {
    const selectedAppId = event.target.value;
    const selectedApp = APPS.find((app) => app.id === selectedAppId);

    if (selectedApp && selectedApp.id !== currentApp) {
      // Navigate to the selected app
      window.location.href = selectedApp.url;
    }
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <FormControl
        size="small"
        sx={{
          minWidth: 100,
        }}
      >
        <Select
          value={currentApp}
          onChange={handleChange}
          sx={(theme) => ({
            color: "text.primary",
            bgcolor: "transparent",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "divider",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "primary.main",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "primary.main",
            },
            ...theme.applyStyles("dark", {
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "divider",
              },
            }),
          })}
        >
          {APPS.map((app) => (
            <MenuItem key={app.id} value={app.id}>
              {app.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
